// Vue imports.
import { reactive } from 'vue'

export let state = reactive({
    justReloaded: false
})